import UserService from "../../../services/UserService";
import { required, minLength, sameAs } from "vuelidate/lib/validators";
import { alertResponseError, alertResponseSuccess } from "../../../helpers/general";
import { ERRORS_CODE } from "../../../const/error_code";
import { checkRoleAdmin } from "../Mixin/checkRoleAdmin";

export default {
    data() {
        return {
            formSubmitted: false,
            isAllowEdit: false,
            isAdmin: false,
            user: {
                id: ''
            },
            passwordData: {
                old_password: '',
                password: '',
                password_confirm: '',
            },
            errors: {
                password: '',
            }
        }
    },
    mixins: [checkRoleAdmin],
    validations() {
        return {
            passwordData: {
                old_password: { required, minLength: minLength(6) },
                password: {
                    required,
                    minLength: minLength(6),
                    isInvalid(value) {
                        return /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/.test(value);
                    }
                },
                password_confirm: { required, sameAsPassword: sameAs('password') },
            }
        }
    },
    computed: {
        passwordOldError() {
            if (!this.$v.passwordData.old_password.required) {
                return this.$t('user_change_password.password_old_required');
            }
            if (this.errors && this.errors.password) {
                return this.$t('message_error.CURRENT_PASSWORD_NOT_MATCH');
            }
            return null;
        },
        passwordNewError() {
            if (!this.$v.passwordData.password.required) {
                return this.$t('user_change_password.password_new_required');
            }
            if (!this.$v.passwordData.password.isInvalid) {
                return this.$t('common_errors.password_invalid', { field: this.$t('common.password'), min: this.$v.passwordData.password.$params.minLength.min });
            }
            return null;
        },
        passwordConfirmError() {
            if (!this.$v.passwordData.password_confirm.required) {
                return this.$t('user_change_password.password_new_confirm_required');
            }
            if (!this.$v.passwordData.password_confirm.sameAsPassword) {
                return this.$t('user_change_password.password_new_not_confirm');
            }
            return null;
        },
    },
    created() {
        document.title = this.$t(`${this.$route.meta.title}.title_page`);
        this.user.id = this.$route.params.id;
    },
    mounted() {
        const loginUser = JSON.parse(localStorage.getItem('user'));
        this.checkRoleAdmin(loginUser);
        if (!this.isAllowEdit) {
            this.$router.replace({ name: 'UserManagement' });
        }
    },
    methods: {
        handleForm() {
            this.formSubmitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                UserService.changePasswordUser(this.passwordData, this.user.id).then((response) => {
                    this.formSubmitted = false;
                    if (response.data.success) {
                        alertResponseSuccess(this.$t('common_message.update_success'));
                        this.$router.push({ name: 'UserManagement' });
                    }
                }).catch((error) => {
                    if (error.response.data.errorCode === ERRORS_CODE.PASSWORD_NOT_MATCH) {
                        this.errors.password = this.$t('message_error.CURRENT_PASSWORD_NOT_MATCH');
                    }
                    alertResponseError(this.$t('message_error.CURRENT_PASSWORD_NOT_MATCH'));
                });
            }
        },
    }
}
